import { render, staticRenderFns } from "./auth-oa-redirect.vue?vue&type=template&id=b188555c&"
import script from "./auth-oa-redirect.vue?vue&type=script&lang=js&"
export * from "./auth-oa-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b188555c')) {
      api.createRecord('b188555c', component.options)
    } else {
      api.reload('b188555c', component.options)
    }
    module.hot.accept("./auth-oa-redirect.vue?vue&type=template&id=b188555c&", function () {
      api.rerender('b188555c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/auth-oa-redirect.vue"
export default component.exports